import { Button, Form, Modal } from "react-bootstrap";
import InputText from "../../InputText/InputText";
import { useCallback, useEffect, useState } from "react";
import useAxios from "../../../auth/useAxios";
import Dropdown from "../../DropDown/DropDown";
import TextArea from "../../TextArea/TextArea";
import { useAuth0 } from "@auth0/auth0-react";
import {
  AreaNames,
  ProjectNames,
} from "../../../../global-types/CompanySettingsTypes";

const transmissionTypes = [
  { label: "Ingen", value: 0, id: "0" },
  { label: "Eksternt API", value: 1, id: "1" },
  { label: "UDP", value: 2, id: "2" },
  { label: "Gemini Live", value: 3, id: "3" },
];

type CreateAreaModalProps = {
  show: boolean;
  onHide: any;
  companyId: string;
};

const CreateDeviceModal: React.FC<CreateAreaModalProps> = ({
  show,
  onHide,
  companyId,
}) => {
  const [deviceName, setDeviceName] = useState<string>("");
  const [deviceIdName, setDeviceIdName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [customerSystemName, setCustomerSystemName] = useState<string>("");
  const [transmissionAddress, setTransmissionAddress] = useState<string>("");

  const [divisor, setDivisor] = useState<number>(1);
  const [transmissionPort, setTransmissionPort] = useState<number>(0);

  const [selectedProjectId, setSelectedProjectId] = useState<number>(0);
  const [selectedProject, setSelectedProject] = useState<any>();
  const [selectedDeviceAreaId, setSelectedDeviceAreaId] = useState<number>(0);
  const [selectedDeviceArea, setSelectedDeviceArea] = useState<any>();
  const [selectedTransmissionTypeId, setSelectedTransmissionTypeId] =
    useState<number>(0);
  const [distanceToBottom, setDistanceToBottom] = useState<number>(0);
  const [selectedTransmissionType, setSelectedTransmissionType] =
    useState<any>();
  // const [allProjects, setAllProjects] = useState<ProjectNames[]>([]);
  // const [allAreas, setAllAreas] = useState<AreaNames[]>([]);
  const [projectItemsForDropdown, setProjectItemsForDropdown] = useState<any[]>(
    []
  );
  const [deviceAreaItemsForDropdown, setDeviceAreaItemsForDropdown] = useState<
    any[]
  >([]);
  const { post, get } = useAxios();

  const getCompanyData = useCallback(async () => {
    try {
      console.log("companyId " + companyId);
      await get("company/" + companyId).then((response) => {
        const projects: ProjectNames[] = response.data.projects;
        const areas: AreaNames[] = response.data.deviceAreas;
        // setAllProjects(projects);
        // setAllAreas(areas);
        setProjectItemsForDropdown(
          projects?.map((project, i) => {
            return { label: project.name, value: project.id, id: "" + i };
          })
        );
        setDeviceAreaItemsForDropdown(
          areas?.map((deviceArea, i) => {
            return {
              label: deviceArea.name,
              value: deviceArea.id,
              id: "" + i,
            };
          })
        );
      });
    } catch {
      console.log("Failed to get admin data");
    }
  }, [companyId]);

  useEffect(() => {
    if (companyId != null && show) {
      console.log("get company data" + companyId);
      getCompanyData();
    }
  }, [companyId, show, getCompanyData]);

  if (companyId === undefined) {
    return null;
  }

  function handleSubmit(event: any) {
    event.preventDefault();
    event.stopPropagation();
    console.log(deviceName);
    try {
      post("device", {
        unitName: deviceName,
        name: deviceName,
        deviceId: deviceIdName,
        description,
        customerSystemName: customerSystemName,
        companyId: companyId,
        deviceAreaId: selectedDeviceAreaId,
        projectId: selectedProjectId,
        unitDivisor: divisor,
        transmissionType: selectedTransmissionTypeId,
        transmissionAddress: transmissionAddress,
        transmissionPort: transmissionPort,
        distanceToBottom: distanceToBottom,
      }).then((response: any) => {
        console.log(response);
        onHide();
      });
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Opprett ny enhet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Dropdown
            items={projectItemsForDropdown}
            onChange={(opt) => {
              setSelectedProjectId(opt.value);
              setSelectedProject(opt);
              console.log(opt.value);
            }}
            placeholder="Prosjekt"
            value={selectedProject}
          />
          <Dropdown
            items={deviceAreaItemsForDropdown}
            onChange={(opt) => {
              setSelectedDeviceAreaId(opt.value);
              setSelectedDeviceArea(opt);
              console.log(opt.value);
            }}
            placeholder="Lokasjon"
            value={selectedDeviceArea}
          />
          <InputText
            value={deviceName}
            onChange={(e: any) => setDeviceName(e.target.value)}
            inputTitle="Navn på enhet"
            label={true}
          />
          <InputText
            value={deviceIdName}
            onChange={(e: any) => setDeviceIdName(e.target.value)}
            inputTitle="ID til enhet"
            label={true}
          />
          <TextArea
            value={description}
            onChange={(e: any) => setDescription(e.target.value)}
            inputTitle="Beskrivelse"
            label={true}
          />
          <InputText
            value={distanceToBottom}
            onChange={(e: any) =>
              setDistanceToBottom(parseFloat(e.target.value))
            }
            inputTitle="Avstand til bunnen"
            label={true}
            type="number"
          />

          <InputText
            value={divisor}
            onChange={(e: any) => setDivisor(parseFloat(e.target.value))}
            inputTitle="Divisor (100 = cm til m)"
            label={true}
            type="number"
          />

          <Dropdown
            items={transmissionTypes}
            onChange={(opt) => {
              setSelectedTransmissionTypeId(opt.value);
              setSelectedTransmissionType(opt);
              console.log(opt.value);
            }}
            placeholder="Overførningstype"
            value={selectedTransmissionType}
          />
          {(selectedTransmissionTypeId === 1 ||
            selectedTransmissionTypeId === 3) && (
            <InputText
              value={customerSystemName}
              onChange={(e: any) => setCustomerSystemName(e.target.value)}
              inputTitle="Enhetsnavn i mottager system"
              label={true}
            />
          )}
          {(selectedTransmissionTypeId === 1 ||
            selectedTransmissionTypeId === 2) && (
            <InputText
              value={transmissionAddress}
              onChange={(e: any) => setTransmissionAddress(e.target.value)}
              inputTitle="Mottager adresse"
              label={true}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit">Lagre</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CreateDeviceModal;
